// extracted by mini-css-extract-plugin
export var accent = "_2z-4";
export var add = "_2z-j";
export var addIcon = "_2z-k";
export var deleteIcon = "_2z-i";
export var disabled = "_2z-9";
export var ellipsis = "_2z-f";
export var error = "_2z-3";
export var form = "_2z-5";
export var hideFocus = "_2z-2";
export var icon = "_2z-7";
export var input = "_2z-e";
export var listItem = "_2z-h";
export var mediumHeight = "_2z-b";
export var noBorder = "_2z-8";
export var noRadius = "_2z-1";
export var shortHeight = "_2z-a";
export var tallHeight = "_2z-c";
export var textInput = "_2z-0";
export var vertical = "_2z-g";
export var veryTallHeight = "_2z-d";
export var widget = "_2z-6";